module.exports = __webpack_public_path__ + "./assets/icons/grange-colombe.jpg";